import { debounce } from 'helpers/otelloUtils';
import {
  createSafeResizeObserver,
  disconnectSafeResizeObserver,
  observeSafeResizeObserver,
  unobserveSafeResizeObserver,
} from 'dashboard/helper/resizeObserver';

const RESIZE_OBSERVER_DEBOUNCE_TIME = 100;

function createResizeObserver(el, binding) {
  const { value } = binding;
  const observer = createSafeResizeObserver(
    debounce((entries) => {
      const entry = entries[0];
      if (entry && value && typeof value === 'function') {
        value(entry);
      }
    }, RESIZE_OBSERVER_DEBOUNCE_TIME)
  );
  if (!observer) {
    return;
  }

  el.cwResizeObserver = observer;
  observeSafeResizeObserver(observer, el);
}

function destroyResizeObserver(el) {
  if (el.cwResizeObserver) {
    unobserveSafeResizeObserver(el.cwResizeObserver, el);
    disconnectSafeResizeObserver(el.cwResizeObserver);
    delete el.cwResizeObserver;
  }
}

export default {
  mounted(el, binding) {
    createResizeObserver(el, binding);
  },
  updated(el, binding) {
    if (binding.oldValue !== binding.value) {
      destroyResizeObserver(el);
      createResizeObserver(el, binding);
    }
  },
  unmounted(el) {
    destroyResizeObserver(el);
  },
};
